import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Gift, LayoutGrid, FileText, User } from 'lucide-react';
import {
  FloatingActionPanelRoot,
  FloatingActionPanelTrigger,
  FloatingActionPanelContent,
  FloatingActionPanelButton,
} from './ui/floating-action-panel';

const CAMPAIGN_OPTIONS = [
  { path: '/kampanyalar/genel', label: 'Genel Kampanyalar', icon: <LayoutGrid className="h-4 w-4" /> },
  { path: '/kampanyalar/bana-ozel', label: 'Bana Özel', icon: <User className="h-4 w-4" /> },
  { path: '/kampanyalar/taslaklar', label: 'Taslak Kampanyalar', icon: <FileText className="h-4 w-4" /> },
];

function getCurrentLabel(pathname) {
  if (pathname?.includes('/taslaklar')) return 'Taslaklar';
  if (pathname?.includes('/bana-ozel')) return 'Bana Özel';
  return 'Genel';
}

export default function CampaignTypeSwitcher() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentLabel = getCurrentLabel(pathname);

  return (
    <FloatingActionPanelRoot>
      {({ closePanel }) => (
        <>
          <FloatingActionPanelTrigger title="Kampanya Türü" mode="actions">
            <Gift className="h-4 w-4 mr-2" />
            {currentLabel}
          </FloatingActionPanelTrigger>

          <FloatingActionPanelContent>
            <div className="space-y-0.5 p-2 pb-3">
              {CAMPAIGN_OPTIONS.map((opt) => (
                <FloatingActionPanelButton
                  key={opt.path}
                  onClick={() => {
                    navigate(opt.path);
                    closePanel();
                  }}
                >
                  {opt.icon}
                  {opt.label}
                </FloatingActionPanelButton>
              ))}
            </div>
          </FloatingActionPanelContent>
        </>
      )}
    </FloatingActionPanelRoot>
  );
}
